module.exports = __webpack_public_path__ + "img/play-video.17ed983f.svg";